module.exports = __webpack_public_path__ + "static/media/adv-img2.b98849ca.jpg";